import { Box } from '#/box';
import type { MultiBufferStream } from '#/buffer';

export class stypBox extends Box {
  static override readonly fourcc = 'styp' as const;
  box_name = 'SegmentTypeBox' as const;

  major_brand: string;
  minor_version: number;
  compatible_brands: Array<string>;

  parse(stream: MultiBufferStream) {
    let toparse = this.size - this.hdr_size;
    this.major_brand = stream.readString(4);
    this.minor_version = stream.readUint32();
    toparse -= 8;
    this.compatible_brands = [];
    let i = 0;
    while (toparse >= 4) {
      this.compatible_brands[i] = stream.readString(4);
      toparse -= 4;
      i++;
    }
  }

  write(stream: MultiBufferStream) {
    this.size = 8 + 4 * this.compatible_brands.length;
    this.writeHeader(stream);
    stream.writeString(this.major_brand, undefined, 4);
    stream.writeUint32(this.minor_version);
    for (let i = 0; i < this.compatible_brands.length; i++) {
      stream.writeString(this.compatible_brands[i], undefined, 4);
    }
  }
}
